//constants
import { tranStr } from "../../utils/translation";
import { commaWithNaN } from "../../helpers/common.functions";

export const SPECIFICATION_CONSTANTS = {
  projectSustainabilityMetricsInfo: "Project Sustainability Metrics",
  projectSustainabilityMetricsList: [
    {
      key: "environmentalAssessmentMethod1",
      label: tranStr("Environmental Assessment Method (EAM)"),
    }, //P6.1
    { key: "eamRatingAchieved1", label: tranStr("EAM Rating Achieved - 1") }, //P6.2
    {
      key: "environmentalAssessmentMethod2",
      label: tranStr("Environmental Assessment Method (EAM) - 2"),
    }, //P6.3
    { key: "eamRatingAchieved2", label: tranStr("EAM Rating Achieved - 2") }, //P6.4
    {
      key: "environmentalAssessmentMethod3",
      label: tranStr("Environmental Assessment Method (EAM) - 3"),
    }, //P6.5
    { key: "eamRatingAchieved3", label: tranStr("EAM Rating Achieved - 3") }, //P6.6
    {
      key: "energyPerformanceRatingMethod1",
      label: tranStr("Energy Performance Rating Method - 1"),
    }, //P6.7
    {
      key: "energyPerformanceRatingAchieved1",
      label: tranStr("Energy Performance Rating Achieved - 1"),
    }, //P6.8
    {
      key: "energyPerformanceRatingMethod2",
      label: tranStr("Energy Performance Rating Method - 2"),
    }, //P6.9
    {
      key: "energyPerformanceRatingAchieved2",
      label: tranStr("Energy Performance Rating Achieved - 2"),
    }, //P6.10
    {
      key: "otherEnvironmentOrWellness",
      label: tranStr("Other environment / wellness standards met"),
    }, //P6.11
    {
      key: "otherEnvironmentOrWellnessRatingAchieved",
      label: tranStr("Rating Achieved"),
    }, //P6.12
  ],

  projectSpecificationInfo: "Project Specification",
  projectSpecificationList: [
    { key: "frameType", label: tranStr("Frame Type") },
    { key: "primaryFacade", label: tranStr("Primary Facade") },
    { key: "secondaryFacade", label: tranStr("Secondary Facade") },
    { key: "windowType", label: tranStr("Window Type") },
    { key: "roofStructure", label: tranStr("Roof Structure") },
    { key: "roofCovering", label: tranStr("Roof Covering") },
    { key: "wallFinishes", label: tranStr("Wall Finishes") },
    { key: "floorFinishes", label: tranStr("Floor Finishes") },
    { key: "heatingSystem", label: tranStr("heating System") },
    { key: "coolingSystem", label: tranStr("Cooling System") },
    { key: "lighting", label: tranStr("Lighting") },
  ],

  projectScheduleSpecificationInfo: "Project Schedule Specification",
  projectScheduleSpecificationList: [
    {
      key: "design_phase_duration",
      label: tranStr("Design Phase Duration (Weeks)"),
    },
    {
      key: "planned_construction_duration",
      label: tranStr("Planned Construction Duration (Weeks"),
    },
    {
      key: "actual_construction_duration",
      label: tranStr("Actual Construction Duration (Weeks)"),
    },
    {
      key: "construction_cost_per_week",
      label: tranStr("Construction Cost per Week"),
      tooltip: () => {
        return (
          <p>
            <b>Construction Cost per Week = </b>Planned Project's Construction
            Duration / Project's Total Construction Cost
          </p>
        );
      },
    },
  ],
};

export function generateProjectSchedules(benchmark) {
  benchmark.design_phase_duration = getDurationBetweenDates(
    benchmark?.designPhaseCompletionDate,
    benchmark?.designPhaseStartDate
  )?.inWeeks;
  benchmark.planned_construction_duration = getDurationBetweenDates(
    benchmark?.contractedCompletionDate,
    benchmark?.startOnSiteDate
  )?.inWeeks;
  benchmark.actual_construction_duration = getDurationBetweenDates(
    benchmark?.actualCompletionDate,
    benchmark?.startOnSiteDate
  )?.inWeeks;
  benchmark.construction_cost_per_week = commaWithNaN(
    Math.round(
      benchmark?.construction_cost / benchmark?.planned_construction_duration
    )
  );
  return benchmark;
}
export function getDurationBetweenDates(date1, date2) {
  const startDate = new Date(date1);
  const endDate = new Date(date2);

  const startMs = startDate.getTime();
  const endMs = endDate.getTime();

  const differenceMs = Math.abs(endMs - startMs); // Use Math.abs for positive difference
  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const daysDifference = Math.round(differenceMs / millisecondsPerDay);
  return {
    inDays: daysDifference,
    inWeeks: commaWithNaN(Math.round(daysDifference / 7)),
  }; // Returns the whole number of days
}
